<template>
    <div class="position-relative">
        <v-data-table
            :headers="table.content.headers.filter((item)=> item.value !== 'id')"
            :items="table.content.body"
            :pagination="table.content.pagination"
            :total-items="table.content.pagination.totalItems"
            sort-icon="keyboard_arrow_down"
            class="table-list training-management-table"
            hide-actions
        >

            <template #headers="props">
                <tr>
                    <template
                        v-for="header in props.headers"
                    >
                        <th v-if="header.value !== 'action'" :key="header.value"
                            :class="[
                                'column sortable',
                                table.content.pagination.descending ? 'desc' : 'asc',
                                header.value === table.content.pagination.sortBy ? 'active' : ''
                            ]"
                            :width="header.width"
                            height="60px"
                            @click="changeSort(header.value)"
                        >
                            {{ $t(header.text) }}
                            <v-icon small>keyboard_arrow_up</v-icon>
                        </th>
                        <th v-else :key="header.value" height="60px"
                            :width="header.width"
                        >
                            <v-checkbox
                                :input-value="isAllSelected"
                                :value="isAllSelected"
                                color="white"
                                class="justify-center training-management__selection-checkbox training-management__selection-checkbox_white"
                                hide-details
                                :ripple="false"
                                @change="selectAllRows"
                            />
                        </th>
                    </template>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td
                        v-for="(header, key) in table.content.headers"
                        :key="key"
                        class="text-xs-left px-2"
                        :class="{'selected': selectedRows.includes(props.item.id)}"
                    >
                        <div v-if="header.value !== 'action'" class="link link--no-decor px-4 default-text">
                            {{ props.item[header.value] }}
                        </div>
                        <div v-else class="px-2">
                            <v-checkbox
                                v-model="selectedRows"
                                class="justify-center training-management__selection-checkbox"
                                :value="props.item.id"
                                multiple
                                :ripple="false"
                                hide-details
                            />
                        </div>
                    </td>
                </tr>
            </template>

            <template #no-results>
                <div class="body-2 no-data">{{ $t('По запросу ничего не найдено.') }}</div>
            </template>
            <template #no-data>
                <div class="body-2 no-data">{{ $t('По запросу ничего не найдено.') }}</div>
            </template>
        </v-data-table>
        <flying_panel v-if="selectedRows.length" :quantity="selectedRows.length" @close="clearSelectionHandle"
                      @cancel="cancelSelectionCourses"
        />
    </div>
</template>

<script>
import {mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import flying_panel from './Flying_panel.vue';

dayjs.extend(utc);
export default {
  components: {
    flying_panel,
  },
  props: {
    table: {
      type    : Object,
      required: true,
    },
    type: {
      type: String,
    },
    link: {
      type   : String,
      default: '',
    },
    filter: {
      type: Object,
    },
  },
  data() {
    return {
      selectedRows: [],
    };
  },
  computed: {
    includeInSelected() {
      return this.table.content.body.filter((row) => this.selectedRows.includes(row.id));
    },
    isAllSelected() {
      if (this.table.content.body) {
        return this.table.content.body.length &&
          this.table.content.body.filter((row) => this.selectedRows.includes(row.id)).length === this.table.content.body.length;
      }
      return false;
    },
  },
  methods: {
    selectAllRows() {
      if (this.includeInSelected.length === this.table.content.body.length) {
        this.selectedRows = this.selectedRows.filter((selectedRowId) => !this.includeInSelected.some((row) => row.id === selectedRowId));
      } else {
        this.selectedRows = [
          ...this.selectedRows,
          ...this.table.content.body.map((row) => row.id),
        ];
      }
    },
    clearSelectionHandle() {
      this.selectedRows = [];
    },
    async cancelSelectionCourses() {
      await this.delete_assigned_test(this.selectedRows);
      await this.get_completed_courses(this.filter);
      this.selectedRows = [];
    },
    get_date(date) {
      return new dayjs(parseInt(date)).format('DD.MM.YYYY HH:mm:ss');
    },
    ...mapMutations('learning_management/employees', [
      'CHANGE_EMPLOYEES_SORT',
    ]),
    ...mapActions('learning_management/employees', [
      'get_completed_courses',
      'delete_assigned_test',
    ]),
    changeSort(column) {
      this.CHANGE_EMPLOYEES_SORT(column);
      return this.get_completed_courses(this.filter);
    },
  },
};
</script>

<style>
.no-data {
    color: black !important;
}
</style>
